import React, { useMemo, useState } from 'react';

import { FormattedMessage } from 'react-intl';

import flexControls from '@messages/flexControls/flexControls';
import Steps from '@pages/flexControls/createFlexControl/enums';
import FlexControlsHeader from '@pages/flexControls/createFlexControl/FlexControlsHeader';
import FlexControlSteps from '@pages/flexControls/createFlexControl/FlexControlSteps';
import getEnumTranslation from '@utils/getEnumTranslation';

const CreateControlContainer = () => {
    const [stepperStage, setStepperStage] = useState<Steps>(Steps.BasicDetails);

    const title = (
        <FormattedMessage
            id="CreateAccountControl.title"
            defaultMessage="Add a new account control"
        />
    );

    const getDescription = () => {
        switch (stepperStage) {
            case 0:
                return getEnumTranslation('basic_details', {
                    messages: flexControls,
                });
            case 1:
                return getEnumTranslation('reset_period', {
                    messages: flexControls,
                });
            case 2:
                return getEnumTranslation('conditions', {
                    messages: flexControls,
                });
        }
    };

    const cachedDescription = useMemo(getDescription, [stepperStage]);

    return (
        <>
            <FlexControlsHeader description={cachedDescription} title={title} />
            <FlexControlSteps
                stepperStage={stepperStage}
                setStepperStage={setStepperStage}
            />
        </>
    );
};

export default CreateControlContainer;
